/**
 * Visibilité d'une entrée du menu latéral selon les droits de l'utilisateur.
 *
 * Une entrée peut déclarer `roles` (au moins un), `permission` (une) ou `anyPermission` (au moins une) ;
 * sans contrainte elle est toujours visible. Un groupe (`submenu`) n'est visible que s'il a au moins un
 * élément visible : on ne montre jamais un groupe vide, ni un lien qui aboutirait à un 403.
 */
export function isEntryVisible(entry, { hasRole, hasPermission, isOwner }) {
  // `ownerOnly` : réservé au(x) propriétaire(s) du produit, au-delà du rôle admin.
  if (entry.ownerOnly) return !!(isOwner && isOwner());
  if (entry.roles) return hasRole(entry.roles);
  if (entry.permission) return hasPermission(entry.permission);
  if (entry.anyPermission) return entry.anyPermission.some((p) => hasPermission(p));
  return true;
}

export function visibleSubmenuItems(entry, access) {
  return (entry.submenu?.items ?? []).filter((item) => isEntryVisible(item, access));
}

export function isMenuItemVisible(entry, access) {
  if (!isEntryVisible(entry, access)) return false;
  return entry.submenu ? visibleSubmenuItems(entry, access).length > 0 : true;
}
